/* maaho-product.js - behaviour for sections/maaho-product.liquid: variant
   swatches, gallery, fabric groups, option panels, measurement validation,
   quantity stepper and the full-screen viewer.

   Each group writes its choice into a hidden properties[<Group>] input, so it
   travels with the line item into the cart and the order. Translated strings
   arrive via window.maahoProductStrings - Liquid does not run in asset files.

   The chosen shape decides which measurement boxes show - see
   window.maahoMeasurements and revealBoxesForShape.

   The price is recalculated as the customer types, from maaho.price_table and
   maaho.option_prices, by assets/maaho-price.js. */

(function () {
  'use strict';

  var mainImg = document.getElementById('main-product-image');
  var originalMainImageSrc = mainImg ? mainImg.src : '';

  /* URL templates from file_img_url; only the attribute id is substituted. */
  var pdp = document.querySelector('.pdp');
  var imageTemplates = {
    small: pdp ? pdp.getAttribute('data-image-template-small') : '',
    large: pdp ? pdp.getAttribute('data-image-template-large') : '',
    id: pdp ? pdp.getAttribute('data-image-template-id') : '',
    extension: pdp ? pdp.getAttribute('data-image-template-ext') : ''
  };

  /* The weave sample image is keyed by stock fabric code, not by attribute id -
     several colours are cut from one fabric and share the file. */
  var sampleTemplates = {
    small: pdp ? pdp.getAttribute('data-sample-template-small') : '',
    large: pdp ? pdp.getAttribute('data-sample-template-large') : '',
    id: pdp ? pdp.getAttribute('data-sample-template-code') : ''
  };

  /* --- Helpers --- */

  /** Write a value into one of the hidden properties[...] inputs. */
  function setProp(inputId, value) {
    var input = document.getElementById(inputId);
    if (input) input.value = value;
  }

  /** Mirror the chosen value next to the group heading. */
  function setLabel(labelId, value) {
    var label = document.getElementById(labelId);
    if (label) label.textContent = value;
  }

  /** Mark one button as selected within its group. */
  function selectOnly(buttons, chosen, ariaSelected) {
    buttons.forEach(function (button) {
      button.classList.remove('on');
      if (ariaSelected) button.setAttribute('aria-selected', 'false');
    });
    chosen.classList.add('on');
    if (ariaSelected) chosen.setAttribute('aria-selected', 'true');
  }

  /**
   * @param {string} size          'small' (swatch) or 'large' (main image)
   * @param {string} attributeId
   * @param {string} [extraIndex]  '2' | '3' | '4' for the additional angles
   */
  function attributeImageUrl(size, attributeId, extraIndex, extension, version) {
    var template = imageTemplates[size];
    if (!template || !imageTemplates.id) return '';

    /* The extras are always .jpg; only the fabric's own picture can be another
       type, and the swatch carries it in data-ext when it is not a jpg. */
    var name = 'attr-' + attributeId + (extraIndex ? '_extra_' + extraIndex : '');
    /* The template is a whole address - .../attr-10000_small.png - so it is
       taken apart rather than searched for a name that is not in it. Splitting
       on "attr-10000.png" matched nothing and left every swatch showing the
       first colour's picture.

       Filenames are attr-<id>[_extra_N]<_size>.<type>. The size comes from the
       template, the type from the colour, and only the fabric's own picture can
       be other than jpg - the extras are always jpg. */
    var address = template.split('?')[0];
    var marker = 'attr-' + imageTemplates.id;
    var at = address.indexOf(marker);
    if (at < 0) return '';

    var rest = address.slice(at + marker.length);
    var size = rest.slice(0, rest.lastIndexOf('.'));
    var type = extraIndex ? 'jpg' : (extension || imageTemplates.extension || 'jpg');

    /* An address with no ?v= is a bare CDN path, and the CDN caches by path: a
       name that once held another picture goes on serving it from the edge.
       The version is the clicked colour's own, from data-picture-version, so
       replacing its picture changes the address. The extras share it - they are
       re-uploaded alongside. */
    var query = version ? '?v=' + encodeURIComponent(version) : '';
    return address.slice(0, at) + name + size + '.' + type + query;
  }

  /**
   * @param {string} size        'small' or 'large'
   * @param {string} fabricCode  the stock fabric, e.g. 'S8101'
   */
  function sampleImageUrl(size, fabricCode) {
    var template = sampleTemplates[size];
    if (!template || !sampleTemplates.id) return '';

    /* The template's ?v= is kept rather than dropped: a bare CDN path serves
       whatever was first cached under that name. One sample image per stock
       fabric, so there is no per-code version to carry. */
    var at = template.indexOf('?');
    var query = at < 0 ? '' : template.slice(at);
    return template.slice(0, at < 0 ? template.length : at)
      .split('fabric-' + sampleTemplates.id + '_sample')
      .join('fabric-' + fabricCode + '_sample') + query;
  }

  /**
   * Show a fabric: its photo as the main image, thumbnail rail rebuilt.
   *
   * @param {string} attributeId
   * @param {string} extras       '234' - which additional angles the fabric has
   * @param {string} [sampleCode] stock fabric code, when a weave sample image exists
   * @param {string} [version]    this colour's ?v=, from data-picture-version
   */
  function showFabricGallery(attributeId, extras, sampleCode, extension, version) {
    var large = attributeImageUrl('large', attributeId, '', extension, version);
    if (!large) return;

    if (mainImg) {
      mainImg.onerror = function () {
        mainImg.onerror = null;
        mainImg.src = originalMainImageSrc;
      };
      showMainImage(large);
    }

    var rail = document.getElementById('thumbs');
    if (!rail) return;

    /* Render first, then the styled shots, then the fabric sample image last -
       the same order the section renders server-side. */
    var views = [{ small: attributeImageUrl('small', attributeId, '', extension, version),
                   large: attributeImageUrl('large', attributeId, '', extension, version) }];

    (extras || '').split('').forEach(function (extraIndex) {
      views.push({ small: attributeImageUrl('small', attributeId, extraIndex, '', version),
                   large: attributeImageUrl('large', attributeId, extraIndex, '', version) });
    });

    if (sampleCode && sampleImageUrl('large', sampleCode)) {
      views.push({ small: sampleImageUrl('small', sampleCode),
                   large: sampleImageUrl('large', sampleCode) });
    }

    /* Framivo: thumbs marked data-keep (profile drawings) are common to all
       colours and stay at the end of the rail. */
    var keptThumbs = Array.prototype.slice.call(rail.querySelectorAll('[data-keep]'));

    rail.textContent = '';

    views.forEach(function (view, position) {
      var thumb = document.createElement('img');
      thumb.className = 'thumb' + (position === 0 ? ' on' : '');
      thumb.src = view.small;
      thumb.setAttribute('data-full', view.large);
      thumb.alt = '';
      thumb.loading = 'lazy';
      thumb.width = 84;
      thumb.height = 84;
      rail.appendChild(thumb);
    });

    keptThumbs.forEach(function (thumb) {
      thumb.classList.remove('on');
      rail.appendChild(thumb);
    });

    bindThumbs();   // the rail was replaced
  }

  /**
   * Point the free-sample button at the sample paired to the fabric just picked.
   *
   * window.maahoFabricSamples is custom.fabric_samples - PrestaShop's own pairing,
   * attribute id to sample variant id. Not every fabric has one, and a button left
   * pointing at the previous fabric's sample would send the wrong swatch, so it is
   * hidden rather than left stale.
   *
   * assets/maaho-sample.js reads the two data attributes set here.
   */
  /**
   * Whether any fabric in this group has a paired sample.
   *
   * Only such a group drives the sample button. A product can offer a second
   * fabric group that PrestaShop never paired - picking from that one must not
   * blank a button the first group set.
   */
  function groupHasPairedSample(buttons) {
    var samples = window.maahoFabricSamples;
    if (!samples) return false;
    return Array.prototype.some.call(buttons, function (button) {
      return Boolean(samples[button.getAttribute('data-aid')]);
    });
  }

  function syncSampleButton(attributeId, colourName) {
    var button = document.getElementById('fabric-sample-button');
    if (!button) return;

    var samples = window.maahoFabricSamples;
    var variantId = (samples && attributeId) ? samples[attributeId] : null;
    if (!variantId) {
      button.hidden = true;
      return;
    }
    button.setAttribute('data-sample-variant', String(variantId));
    button.setAttribute('data-sample-colour', colourName || '');
    button.hidden = false;
  }

  /* --- Live price ---
     The price shown has to match what the checkout will charge, so both use the
     same arithmetic: this reads assets/maaho-price.js, the pricing function reads
     its TypeScript twin, and one set of database-derived cases tests both.

     Selections are held here rather than read back out of the DOM, so the id list
     and the price always describe the same configuration. */

  var pricing = window.maahoPricing || null;
  /* Both the heading and the add-to-cart button show the price, and both start as
     the "from" price the section rendered. */
  var PRICE_ELEMENT_IDS = ['price', 'add-to-cart-price'];

  function priceElements() {
    return PRICE_ELEMENT_IDS
      .map(function (id) { return document.getElementById(id); })
      .filter(Boolean);
  }

  (function rememberFromPrice() {
    priceElements().forEach(function (element) {
      element.setAttribute('data-from-price', element.textContent);
    });
  })();
  var chosenByGroup = {};                       // groupId -> attributeId

  /* --- Add to cart gating ---
     A group with no real default (e.g. Skum) opens on "---" and blocks
     Add to cart until the customer picks something. requiredGroupIds is
     filled in by initFabricGroups and initOptionPanels.

     The button looks disabled but never gets the real disabled attribute:
     that would block clicks entirely, and the customer would have no way
     to find out which group still needs a choice. Blocking happens on the
     form's submit instead, which also covers the Enter key. */
  var submitButton = document.querySelector('.addbar button[type="submit"]');
  var form = submitButton ? submitButton.closest('form') : null;
  var requiredGroupIds = [];
  var groupHighlightTargets = {};               // propId -> element to scroll to / outline
  var measurementsComplete = function () { return true; };            // overridden by initDimensions, if it runs
  var findFirstIncompleteMeasurement = function () { return null; };  // ditto
  var revalidateMeasurements = function () {};                        // ditto

  /* Shown in place of a price for a size the grid cannot price. A dash rather than a
     sentence: the red fields and the blocked button already say it is not orderable,
     and the range beneath each field says what is allowed. */
  var NO_PRICE = '-';

  /* True when both measurements are filled in and within their range, but the grid
     holds no price for that pair -- a hole in the supplier's price list. Deliberately
     separate from isOutOfRange, which tests one field against its own min and max;
     this is a fact about the combination and no single field is wrong. */
  var sizeHasNoPrice = false;

  /** Revalidate only when it actually changed -- validate() touches the DOM. */
  function setSizeHasNoPrice(value) {
    if (sizeHasNoPrice === value) return;
    sizeHasNoPrice = value;
    revalidateMeasurements();
  }

  function isReady() {
    var groupsReady = requiredGroupIds.every(function (propId) {
      return Boolean(chosenByGroup[propId]) || hiddenGroupProps[propId];
    });
    return groupsReady && measurementsComplete()
        && readinessChecks.every(function (check) { return check(); });
  }

  /* --- The option groups, for assets/maaho-rules.js ---
     A rule is written in PrestaShop group and attribute ids, which the markup
     already carries as data-option-group and data-aid. Each group registers
     itself under its own id with the few things a rule needs - what is chosen,
     how to choose, how to clear, how to make a value or the whole group
     unavailable - so nothing reaches into a group's internals from outside.

     A hidden group stops being required, or Add to cart would wait forever on a
     choice the customer can no longer see. */
  var groupRegistry = {};
  var hiddenGroupProps = {};
  var changeListeners = [];
  var readinessChecks = [];

  function notifyGroupChange() {
    changeListeners.forEach(function (listener) { listener(); });
  }

  window.MaahoProductGroups = {
    byGroupId: groupRegistry,
    all: function () {
      return Object.keys(groupRegistry).map(function (groupId) { return groupRegistry[groupId]; });
    },
    holding: function (attributeId) {
      return this.all().filter(function (group) {
        return Object.prototype.hasOwnProperty.call(group.values, String(attributeId));
      })[0] || null;
    },
    onChange: function (listener) { changeListeners.push(listener); },
    addReadinessCheck: function (check) { readinessChecks.push(check); },
    refresh: function () { refreshPrice(); updateAddToCartState(); }
  };

  /**
   * @param {Element} groupElement  the .sw-img or .option-panel carrying data-option-group
   * @param {object}  group         the rest of the group's own interface
   */
  function registerGroup(groupElement, propId, group) {
    var groupId = groupElement.getAttribute('data-option-group');
    if (!groupId) return;

    var row = document.querySelector('[data-option-row="' + groupId + '"]');

    group.groupId = groupId;

    /**
     * Hide or show the whole group.
     *
     * A hidden group takes its choice off the order and out of the price with it:
     * a thread colour the customer was never shown must not appear on the line the
     * workshop reads, and must not be charged for. The choice is remembered, so
     * showing the group again puts it back rather than making them pick afresh.
     *
     * @returns {boolean} true when the selection changed, so the rules re-run
     */
    group.setHidden = function (hidden) {
      if (row) row.hidden = hidden;
      hiddenGroupProps[propId] = hidden;

      var property = document.getElementById(propId);
      if (property) property.disabled = hidden;   // a hidden input would still submit its key

      if (hidden && group.chosenId()) {
        group.selectionWhileHidden = group.chosenId();
        group.clear();
        return true;
      }
      if (!hidden && group.selectionWhileHidden) {
        var restore = group.selectionWhileHidden;
        group.selectionWhileHidden = null;
        group.select(restore);
        return true;
      }
      return false;
    };
    group.setValueState = function (attributeId, state) {
      var element = group.values[attributeId];
      if (!element) return;
      element.hidden = state.hidden;
      element.classList.toggle('is-unavailable', state.unavailable);
      element.setAttribute('aria-disabled', state.unavailable ? 'true' : 'false');
    };
    group.canSelect = function (attributeId) {
      var element = group.values[String(attributeId)];
      return Boolean(element) && !element.hidden && !element.classList.contains('is-unavailable');
    };

    groupRegistry[groupId] = group;
  }

  /** The values a group offers, by the PrestaShop attribute id in the markup. */
  function valuesByAttributeId(elements) {
    var values = {};
    elements.forEach(function (element) {
      var attributeId = element.getAttribute('data-aid');
      if (attributeId) values[attributeId] = element;
    });
    return values;
  }

  function updateAddToCartState() {
    if (!submitButton) return;
    submitButton.classList.toggle('is-incomplete', !isReady());
  }

  /** Scroll to it, outline it briefly, no wording -- the customer already
      knows they clicked Add to cart; the point is showing which choice
      still needs making. */
  function flagAsMissing(element) {
    if (!element) return;
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    element.classList.add('needs-attention');
    setTimeout(function () { element.classList.remove('needs-attention'); }, 2500);
  }

  function focusFirstIncompleteRequirement() {
    var missingGroupId = requiredGroupIds.filter(function (propId) {
      return !chosenByGroup[propId];
    })[0];
    if (missingGroupId) {
      flagAsMissing(groupHighlightTargets[missingGroupId]);
      return;
    }
    flagAsMissing(findFirstIncompleteMeasurement());
  }

  /*
    The pricing function expands a made-to-measure line into a one-component
    bundle. Shopify keeps these properties on the bundle parent, while order
    notifications render the component. Give the function one compact,
    localized copy of every customer-visible property so it can attach the same
    names and values to that component.

    Each transport property is deliberately underscored, so it stays out of the
    cart and checkout. Three 250-character pieces cover the largest Maaho product
    configuration with room for translated labels; refusing an overflow is safer
    than sending a confirmation that silently omits workshop-critical details.
  */
  var NOTIFICATION_DETAILS_PARTS = 3;
  var NOTIFICATION_DETAILS_PART_SIZE = 250;

  function syncNotificationDetails() {
    if (!form) return true;

    var details = [];
    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      if (input.disabled || !input.value) return;

      var name = input.getAttribute('name') || '';
      var match = name.match(/^properties\[(.*)\]$/);
      if (!match || !match[1] || match[1].charAt(0) === '_') return;

      details.push([match[1], input.value]);
    });

    var serialized = JSON.stringify(details);
    var capacity = NOTIFICATION_DETAILS_PARTS * NOTIFICATION_DETAILS_PART_SIZE;
    if (serialized.length > capacity) return false;

    for (var part = 0; part < NOTIFICATION_DETAILS_PARTS; part += 1) {
      setProp(
        'notification-details-' + (part + 1),
        serialized.slice(
          part * NOTIFICATION_DETAILS_PART_SIZE,
          (part + 1) * NOTIFICATION_DETAILS_PART_SIZE
        )
      );
    }
    return true;
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      if (!isReady()) {
        event.preventDefault();
        focusFirstIncompleteRequirement();
        return;
      }
      if (!syncNotificationDetails()) event.preventDefault();
    });
  }

  /* Framivo: sizes other than the frame's that a '#' surcharge may price by,
     keyed by line property - e.g. '_mat_opening' from the passepartout window,
     supplied by assets/framivo-passepartout-hulmaal.js. */
  function extraMeasures() {
    return typeof window.maahoExtraMeasures === 'function' ? window.maahoExtraMeasures() : null;
  }

  function chosenOptionIds() {
    return Object.keys(chosenByGroup)
      .map(function (groupId) { return chosenByGroup[groupId]; })
      .filter(Boolean);
  }

  /* Each language writes money differently -- 1.155,00 kr. in Danish, 1 155,00 kr
     in Swedish, € 1.155,00 in Dutch -- so the browser formats it rather than
     this file guessing.

     Two decimals: prices are exact, so 835,00 kr and 216,82 € are both written
     out in full. */
  var moneyFormatter = (function () {
    if (!pricing || !pricing.currency || typeof Intl === 'undefined') return null;
    try {
      return new Intl.NumberFormat(pricing.locale || undefined, {
        style: 'currency',
        currency: pricing.currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (unsupported) {
      return null;
    }
  })();

  /** 1155 -> "1.155,00 kr." in Danish. */
  function formatPrice(amount) {
    if (moneyFormatter) return moneyFormatter.format(amount);

    // Shopify's own money_format, with the amount written the Danish way.
    var parts = amount.toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var body = whole + ',' + parts[1];
    var format = (pricing && pricing.moneyFormat) || '{{amount}} kr';
    return format.replace(/\{\{\s*amount[^}]*\}\}/, body);
  }

  /* The second measurement to price with. The grid is read on two axes even when
     the shape hides that box, so a diameter repeats the width and a single-axis
     grid uses its only step. */
  function secondMeasurementForPrice(width) {
    var input = document.getElementById('measurement-length');
    if (input && !input.disabled) return parseFloat(input.value);
    if (window.maahoMeasurements && window.maahoMeasurements.secondFromWidth) return width;
    return pricing.priceTable.second.values[0];
  }

  /*
    The measurements under their Danish names, for the hidden _measurements property.

    The visible measurement properties carry the buyer's own language, because Shopify
    shows a property's key in the cart and at checkout and a German buyer must not be
    shown "Bredde". This line is what the workshop and the shipping rules read, so it has
    to read the same in every language -- the Danish name comes from data-measurement on
    each input, which maaho-measurement-field.liquid sets.

    A disabled box belongs to a shape that does not use it, and is left out.
  */
  function measurementValues() {
    var pairs = [];
    document.querySelectorAll('.measurement-field input[data-measurement]')
      .forEach(function (input) {
        if (input.disabled || input.value === '') return;
        pairs.push(input.getAttribute('data-measurement') + ':' + input.value);
      });
    return pairs.join(';');
  }

  /* Recalculate and repaint. Called on every change to a measurement or an option. */
  function refreshPrice() {
    var idsInput = document.getElementById('chosen-option-ids');
    if (idsInput) idsInput.value = chosenOptionIds().join(',');

    var measurementsInput = document.getElementById('measurement-values');
    if (measurementsInput) measurementsInput.value = measurementValues();

    if (!pricing || !window.MaahoPrice) return;

    /* A product with no size grid comes in one size at one price, and its options
       are priced against that price. There is nothing to measure, so the total is
       the product's own price plus whatever is chosen.

       The base is maaho.base_price, ex VAT in DKK -- the same basis as a grid cell,
       so maaho-price.js applies the VAT and the currency in one place for both. */
    if (!pricing.priceTable) {
      if (typeof pricing.baseExcludingVat !== 'number') return;

      var withoutGrid = window.MaahoPrice.calculate(
        null,
        pricing.optionPrices,
        { chosen: chosenOptionIds(), baseExcludingVat: pricing.baseExcludingVat,
          measures: extraMeasures() },
        {
          vatRate: pricing.shopVatRate,
          vatExempt: pricing.vatExempt,
          currencyRate: pricing.currencyRate,
          decimals: pricing.decimals
        }
      );

      if (!withoutGrid) return;

      labelOptionPrices(withoutGrid.base);
      var priced = formatPrice(withoutGrid.total);
      priceElements().forEach(function (element) { element.textContent = priced; });

      /* Not a starting point: this product has one size, so the price with the
         chosen options is the price. */
      var gridlessFromLabel = document.querySelector('.price-lg .fra');
      if (gridlessFromLabel) gridlessFromLabel.hidden = true;
      return;
    }

    var widthInput = document.getElementById('measurement-width');
    var width = widthInput ? parseFloat(widthInput.value) : NaN;
    var second = secondMeasurementForPrice(width);

    var elements = priceElements();
    var fromLabel = document.querySelector('.price-lg .fra');
    if (!elements.length) return;

    /* No measurements yet, so the price shown is the smallest this configuration
       can cost. That still has to include whatever is selected by default: a group
       whose default carries +100 is 100 dearer before the customer touches
       anything, and showing the bare size price makes the total jump for no
       visible reason once a measurement is typed.

       The surcharges are added to the price the section printed rather than to the
       grid's own base. Both describe the smallest size, but the printed one is the
       variant price and is what the customer already has in front of them; the
       grid's carries the rounding the section's comment describes. */
    if (isNaN(width) || isNaN(second)) {
      // Half-typed is not a missing price: clear it, or a field stays red while
      // the customer is still filling the other one in.
      setSizeHasNoPrice(false);
      if (fromLabel) fromLabel.hidden = false;

      var money = {
        vatRate: pricing.shopVatRate,
        vatExempt: pricing.vatExempt,
        currencyRate: pricing.currencyRate,
        decimals: pricing.decimals
      };
      var smallest = {
        width: pricing.priceTable.width.min,
        second: pricing.priceTable.second.min,
        shippingSurcharge: 0
      };

      var bare = window.MaahoPrice.calculate(
        pricing.priceTable, pricing.optionPrices,
        Object.assign({}, smallest, { chosen: [] }), money);
      var chosen = window.MaahoPrice.calculate(
        pricing.priceTable, pricing.optionPrices,
        Object.assign({}, smallest, { chosen: chosenOptionIds(), measures: extraMeasures() }), money);

      if (bare && chosen && typeof pricing.fromPrice === 'number') {
        var addedByDefaults = chosen.total - bare.total;
        var shown = formatPrice(pricing.fromPrice + addedByDefaults);
        elements.forEach(function (element) { element.textContent = shown; });
      } else {
        elements.forEach(function (element) {
          element.textContent = element.getAttribute('data-from-price')
            || element.textContent;
        });
      }

      if (bare) labelOptionPrices(bare.base, smallest.width, smallest.second);
      return;
    }

    var result = window.MaahoPrice.calculate(
      pricing.priceTable,
      pricing.optionPrices,
      {
        width: width,
        second: second,
        chosen: chosenOptionIds(),
        shippingSurcharge: pricing.shippingSurcharge || 0,
          measures: extraMeasures()
      },
      {
        vatRate: pricing.shopVatRate,
        vatExempt: pricing.vatExempt,
        currencyRate: pricing.currencyRate,
        decimals: pricing.decimals
      }
    );

    /* No price for a size the customer is allowed to type: a hole in the price
       list. Both measurements are numbers by now -- the isNaN branch above has
       returned -- so this is not "not finished yet", and leaving the displayed
       figure alone would quote the previous size's price for this one. The fields
       go red and Add to cart is disabled, the same treatment an out-of-range
       measurement gets. */
    if (!result) {
      setSizeHasNoPrice(true);
      /* Clear the figure as well as reddening the fields. Leaving it would show the
         PREVIOUS size's price beside a red field -- type 88x88 then 13x13 and the page
         reads 490,25 for a size that cannot be bought. Add to cart is already blocked,
         so this is about not stating a price we would refuse to honour. */
      elements.forEach(function (element) { element.textContent = NO_PRICE; });
      if (fromLabel) fromLabel.hidden = true;
      return;
    }
    setSizeHasNoPrice(false);

    var shown = formatPrice(result.total);
    elements.forEach(function (element) { element.textContent = shown; });
    // It is an exact price now, not a starting point.
    if (fromLabel) fromLabel.hidden = true;

    labelOptionPrices(result.base, width, second);
  }

  /* What each choice would add, shown next to it in the panel -- without this
     a 231 kr option looks free until the total moves. Recomputed on every
     change because a percentage or per-width surcharge follows the measurements.

     Also fills .option-trigger-price, the same figure on the closed row, so the
     cost of what is already chosen is visible without opening the panel. Both
     carry data-aid and are filled identically; the trigger's is rewritten by
     select() as the choice changes. */
  function labelOptionPrices(base, width, second) {
    var labels = document.querySelectorAll('.option-choice-price, .option-trigger-price');
    if (!labels.length) return;

    var surcharges = (pricing.optionPrices && pricing.optionPrices.surcharges) || {};
    var widthStep = (pricing.optionPrices && pricing.optionPrices.width_step) || 20;
    var money = {
      vatRate: pricing.shopVatRate,
      vatExempt: pricing.vatExempt,
      currencyRate: pricing.currencyRate,
      decimals: pricing.decimals
    };

    labels.forEach(function (label) {
      var entry = surcharges[label.getAttribute('data-aid')];
      var amount = entry
        ? window.MaahoPrice.optionAmount(entry, base, width, widthStep, money,
          second, window.MaahoPrice.sharedTables(pricing.optionPrices), extraMeasures())
        : null;
      // No surcharge and zero are both "costs nothing extra" -- say nothing.
      label.textContent = amount ? '+ ' + formatPrice(amount) : '';
    });
  }

  /* --- 1. Variant swatches --- */

  function initVariantSwatches() {
    var group = document.getElementById('variant-swatches');
    if (!group) return;

    var buttons = group.querySelectorAll('.swatch');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        selectOnly(buttons, button);

        var title = button.getAttribute('data-n');
        setProp('selected-variant-id', button.getAttribute('data-vid'));
        setProp('selected-colour-property', title);
        setLabel('variant-selected-label', title);

        var image = button.getAttribute('data-img');
        if (mainImg && image) mainImg.src = image;
      });
    });
  }

  /* --- 2. Gallery thumbnails --- */

  /**
   * Swap the main image, showing a loading state until the new one arrives.
   * Shopify generates each resized image on first request (~0.5s), so only show
   * it if loading is still pending after 120ms - a cached image must not flash.
   */
  function showMainImage(url) {
    if (!mainImg || !url || mainImg.src === url) return;

    var frame = mainImg.closest('.main');
    var pending = window.setTimeout(function () {
      if (frame) frame.classList.add('is-loading');
    }, 120);

    var loader = new Image();
    loader.onload = loader.onerror = function () {
      window.clearTimeout(pending);
      mainImg.src = url;
      if (frame) frame.classList.remove('is-loading');
    };
    loader.src = url;
  }

  /** Attach click handlers to whatever is currently in the thumbnail rail. */
  function bindThumbs() {
    var thumbs = document.querySelectorAll('.thumbs img');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMainImage(thumb.getAttribute('data-full'));
        thumbs.forEach(function (other) { other.classList.remove('on'); });
        thumb.classList.add('on');
      });
    });
  }

  /* --- 3. Fabric / colour groups --- */

  function initFabricGroups() {
    document.querySelectorAll('.sw-img[data-target]').forEach(function (group) {
      var propId = group.getAttribute('data-target');
      var labelId = group.getAttribute('data-label');
      var isShapeGroup = isMeasurementShapeGroup(group);
      var buttons = group.querySelectorAll('.swatch');
      var drivesSampleButton = groupHasPairedSample(buttons);
      if (buttons.length) {
        requiredGroupIds.push(propId);
        groupHighlightTargets[propId] = group;
      }

      /** @param {boolean} swapImages - false on first paint, so the product's own
       *        photography stays until the customer picks a fabric. */
      function select(button, swapImages) {
        selectOnly(buttons, button);

        var colourName = button.getAttribute('data-n');
        var attributeId = button.getAttribute('data-aid');
        setProp(propId, colourName);
        setLabel(labelId, colourName);
        if (drivesSampleButton) syncSampleButton(attributeId, colourName);

        /* Fabric variants exist so collection pages can list a tile per colour.
           Selecting the matching one keeps the order line titled with the fabric
           the customer chose. */
        var fabricVariants = window.maahoFabricVariants;
        if (fabricVariants && fabricVariants[colourName]) {
          setProp('selected-variant-id', fabricVariants[colourName]);
        }

        if (attributeId) {
          chosenByGroup[propId] = attributeId;
          if (isShapeGroup) revealBoxesForShape(attributeId);
          refreshPrice();
          updateAddToCartState();
          group.classList.remove('needs-attention');
        }
        if (swapImages && attributeId) {
          showFabricGallery(attributeId,
                            button.getAttribute('data-extras') || '',
                            button.getAttribute('data-sample') || '',
                            button.getAttribute('data-ext') || '',
                            button.getAttribute('data-picture-version') || '');
        }
      }

      registerGroup(group, propId, {
        values: valuesByAttributeId(Array.prototype.slice.call(buttons)),
        chosenId: function () { return chosenByGroup[propId] || ''; },
        select: function (attributeId) {
          var button = this.values[String(attributeId)];
          if (button) select(button, true);
        },
        clear: function () {
          buttons.forEach(function (button) { button.classList.remove('on'); });
          delete chosenByGroup[propId];
          setProp(propId, '');
          setLabel(labelId, window.maahoProductStrings && window.maahoProductStrings.notSelected);
        }
      });

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          // A rule has taken this one off the table; the class is on the element.
          if (button.classList.contains('is-unavailable')) return;
          select(button, true);
          notifyGroupChange();
        });

        // Warm the large image so the click is instant.
        button.addEventListener('mouseenter', function () {
          if (button.dataset.prefetched) return;
          button.dataset.prefetched = '1';

          var url = attributeImageUrl('large',
                                      button.getAttribute('data-aid'),
                                      '',
                                      button.getAttribute('data-ext') || '',
                                      button.getAttribute('data-picture-version') || '');
          if (url) new Image().src = url;
        }, { passive: true });
      });

      /* Liquid only marks a button .on when there's a real default -- if none,
         this group opens on "---" instead of silently picking the first swatch. */
      var preselected = group.querySelector('.swatch.on');
      if (preselected) {
        select(preselected, false);
      } else {
        setLabel(labelId, window.maahoProductStrings && window.maahoProductStrings.notSelected);
      }
    });
  }

  /* --- 4. Option panels ---
     Native <dialog> + showModal(), so it renders in the top layer and the
     browser supplies the dimming, Escape and focus trapping. */

  var PANEL_CLOSE_FALLBACK_MS = 600;   // longer than the .38s slide-out

  /**
   * Slide the panel out, then close it. close() must not run before the
   * animation ends, or the dialog leaves the top layer mid-slide and app
   * embeds draw over it.
   */
  function closeOptionPanel(panel, immediate) {
    if (!panel.open) return;

    if (immediate) {
      panel.close();
      return;
    }

    if (panel.classList.contains('is-closing')) return;
    panel.classList.add('is-closing');

    var settled = false;
    var timer;

    function finish() {
      if (settled) return;
      settled = true;
      panel.removeEventListener('transitionend', onTransitionEnd);
      clearTimeout(timer);

        // Reopened mid-close: the trigger cleared .is-closing.
      if (!panel.classList.contains('is-closing')) return;
      panel.close();
    }

    function onTransitionEnd(event) {
      if (event.target === panel && event.propertyName === 'transform') finish();
    }

    panel.addEventListener('transitionend', onTransitionEnd);

    timer = setTimeout(finish, PANEL_CLOSE_FALLBACK_MS);
  }

  function closeOptionPanels(immediate) {
    document.querySelectorAll('.option-panel[open]').forEach(function (panel) {
      closeOptionPanel(panel, immediate);
    });
  }

  function initOptionPanels() {
    document.querySelectorAll('.option-panel[data-target]').forEach(function (panel) {
      var propId = panel.getAttribute('data-target');
      var labelId = panel.getAttribute('data-label');
      var isShapeGroup = isMeasurementShapeGroup(panel);
      var trigger = document.querySelector('[data-option-panel="' + panel.id + '"]');
      var current = trigger ? trigger.querySelector('.option-trigger-value') : null;
      var currentPrice = trigger ? trigger.querySelector('.option-trigger-price') : null;
      var choices = panel.querySelectorAll('.option-choice');
      if (choices.length) {
        requiredGroupIds.push(propId);
        // The dialog itself is hidden until opened -- the trigger is what's
        // actually on the page to scroll to and outline.
        groupHighlightTargets[propId] = trigger || panel;
      }

      function select(choice, closeAfter) {
        selectOnly(choices, choice, true);

        var value = choice.getAttribute('data-v');
        var attributeId = choice.getAttribute('data-aid');
        if (attributeId) chosenByGroup[propId] = attributeId;
        if (isShapeGroup) revealBoxesForShape(attributeId);
        // Before refreshPrice, so the closed row's amount is filled by the same
        // pass that fills the panel rather than staying one choice behind.
        if (currentPrice) currentPrice.setAttribute('data-aid', attributeId || '');
        refreshPrice();
        updateAddToCartState();
        if (trigger) trigger.classList.remove('needs-attention');

        if (current) current.textContent = value;
        setProp(propId, value);
        setLabel(labelId, value);   // no-op unless the group shows it in its heading

        if (closeAfter) closeOptionPanel(panel);
      }

      if (trigger) {
        trigger.addEventListener('click', function () {
            // One panel at a time.
          document.querySelectorAll('.option-panel[open]').forEach(function (other) {
            if (other !== panel) closeOptionPanel(other, true);
          });

            // Reverses an in-flight close.
          panel.classList.remove('is-closing');
          if (!panel.open) panel.showModal();

          trigger.setAttribute('aria-expanded', 'true');

          var selected = panel.querySelector('.option-choice.on');
          if (selected) selected.scrollIntoView({ block: 'nearest' });
        });
      }

        // A click on ::backdrop targets the dialog itself.
      panel.addEventListener('click', function (event) {
        if (event.target === panel) closeOptionPanel(panel);
      });

      // preventDefault, or Escape closes instantly and skips the slide-out.
      panel.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeOptionPanel(panel);
      });

      panel.addEventListener('close', function () {
        panel.classList.remove('is-closing');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });

      panel.querySelectorAll('[data-option-panel-close]').forEach(function (button) {
        button.addEventListener('click', function () { closeOptionPanel(panel); });
      });

      registerGroup(panel, propId, {
        values: valuesByAttributeId(Array.prototype.slice.call(choices)),
        chosenId: function () { return chosenByGroup[propId] || ''; },
        select: function (attributeId) {
          var choice = this.values[String(attributeId)];
          if (choice) select(choice, false);
        },
        clear: function () {
          choices.forEach(function (choice) {
            choice.classList.remove('on');
            choice.setAttribute('aria-selected', 'false');
          });
          delete chosenByGroup[propId];
          setProp(propId, '');
          var notSelected = window.maahoProductStrings && window.maahoProductStrings.notSelected;
          if (current) current.textContent = notSelected;
          if (currentPrice) currentPrice.setAttribute('data-aid', '');
          setLabel(labelId, notSelected);
        }
      });

      choices.forEach(function (choice) {
        choice.addEventListener('click', function () {
          if (choice.classList.contains('is-unavailable')) return;
          select(choice, true);
          notifyGroupChange();
        });
      });

      /* No choices[0] fallback: without a real default this panel opens on
         "---", and the customer has to open it and pick one. */
      var preselected = panel.querySelector('.option-choice.on');
      if (preselected) {
        select(preselected, false);
      } else if (current) {
        current.textContent = window.maahoProductStrings && window.maahoProductStrings.notSelected;
      }
    });
  }

  /* --- 5. Made-to-measure dimensions ---
     Native min/max only complains on submit, so validate on every keystroke
     and block Add to cart. Only the boxes the chosen shape uses are required,
     validated and sent. */

  /** Fill %FIELD% / %MIN% / %MAX% in a translated message template. */
  function formatMessage(template, replacements) {
    return Object.keys(replacements).reduce(function (text, token) {
      return text.split('%' + token + '%').join(replacements[token]);
    }, template || '');
  }

  /* Set by initDimensions so a shape choice can change the boxes. */
  var revealBoxesForShape = function () {};

  /** True when this group's choices decide the measurement boxes. */
  function isMeasurementShapeGroup(element) {
    return Boolean(window.maahoMeasurements)
      && element.getAttribute('data-option-group') === window.maahoMeasurements.groupId;
  }

  function initDimensions() {
    var boxes = Array.prototype.slice.call(
      document.querySelectorAll('.measurement-field[data-measurement-box]'));
    if (!boxes.length) return;

    var rules = window.maahoMeasurements || null;

    function inputOf(box) {
      return box.querySelector('input');
    }

    function visibleInputs() {
      return boxes.filter(function (box) { return !box.hidden; }).map(inputOf);
    }

    /* Framivo: measurements take one decimal (55,5 cm) - Jesper's choice, 2 Oct. A number input still
       lets the customer type more, so anything past the first decimal is cut
       off rather than rounded. The grid snaps a decimal up to its next step, and
       so does the pricing function. A number input's value always uses a point,
       whatever the browser shows. */
    function toOneDecimal(input) {
      var parts = input.value.split('.');
      if (parts.length === 2 && parts[1].length > 1) {
        input.value = parts[0] + '.' + parts[1].slice(0, 1);
      }
    }

    function isEmpty(input) {
      return input.value.trim() === '' || isNaN(parseFloat(input.value));
    }

    /**
     * Out of range, and only that. An empty field is not wrong yet -- the
     * customer simply has not got there -- so it is left alone, and Add to cart
     * waits quietly rather than accusing them of a mistake.
     */
    function isOutOfRange(input) {
      if (isEmpty(input)) return false;
      var value = parseFloat(input.value);
      return value < parseFloat(input.getAttribute('min'))
          || value > parseFloat(input.getAttribute('max'));
    }

    /**
     * True when every measurement still on screen is filled in and in range, and
     * the grid actually holds a price for the combination they make.
     */
    function isComplete() {
      if (sizeHasNoPrice) return false;
      return visibleInputs().every(function (input) {
        return !isEmpty(input) && !isOutOfRange(input);
      });
    }

    /* The field and its range turn red; no message as well. The range under the
       field already states what is allowed, so a sentence would repeat it in
       more words. aria-invalid and aria-describedby carry it to screen readers. */
    function validate() {
      visibleInputs().forEach(function (input) {
        /* A missing price is a fault of the pair, so both fields carry it -- there
           is no way to say which of the two the customer should change. */
        var wrong = isOutOfRange(input) || sizeHasNoPrice;
        input.classList.toggle('invalid', wrong);
        input.setAttribute('aria-invalid', wrong ? 'true' : 'false');
      });
      measurementsComplete = isComplete;
      updateAddToCartState();
    }
    revalidateMeasurements = validate;

    // Read by the shared form-submit handler -- see focusFirstIncompleteRequirement.
    findFirstIncompleteMeasurement = function () {
      var inputs = visibleInputs();
      return inputs.filter(isEmpty)[0] || inputs.filter(isOutOfRange)[0]
          || (sizeHasNoPrice ? inputs[0] : null) || null;
    };

    /**
     * Show the boxes this shape needs, and clear the ones it does not so a
     * measurement typed for another shape cannot reach the order or the price.
     *
     * @param {string} [attributeId] the chosen shape. A shape with no rule of
     *        its own falls to rules.boxes -- the default two measurements, never
     *        the extras, which belong to a shape that asks for them by name.
     */
    revealBoxesForShape = function (attributeId) {
      if (!rules) return;

      var wanted = (attributeId && rules.byShape[attributeId]) || rules.boxes || '';
      var changed = false;

      boxes.forEach(function (box) {
        var show = wanted.indexOf(box.getAttribute('data-measurement-box')) > -1;
        if (show === !box.hidden) return;

        changed = true;
        box.hidden = !show;
        var input = inputOf(box);
        input.disabled = !show;   // a hidden input would still submit its value
        if (show) {
          input.setAttribute('required', 'required');
        } else {
          input.removeAttribute('required');
          input.value = '';
          input.classList.remove('invalid', 'needs-attention');
          input.setAttribute('aria-invalid', 'false');
        }
      });

      applyWidthLimit(wanted.indexOf('B') === -1 && rules.secondFromWidth);

      if (changed) {
        validate();
        refreshPrice();
      }
    };

    /* A diameter is read on both grid axes, so it caps at the smaller maximum.
       The visible range is rewritten too, or the field would go red at a value
       the text beneath it calls allowed. */
    function applyWidthLimit(isDiameter) {
      var widthBox = boxes.filter(function (box) {
        return box.getAttribute('data-measurement-box') === 'A';
      })[0];
      if (!widthBox || !rules.diameterMaximum) return;

      var input = inputOf(widthBox);
      var maximum = isDiameter ? rules.diameterMaximum : rules.widthMaximum;
      if (String(maximum) === input.getAttribute('max')) return;

      input.setAttribute('max', maximum);
      var range = widthBox.querySelector('.measurement-limit');
      if (range) {
        range.textContent = formatMessage(rules.rangeTemplate, {
          MIN: input.getAttribute('min'),
          MAX: maximum
        });
      }
    }

    boxes.forEach(function (box) {
      var input = inputOf(box);
      // Runs first: validate and refreshPrice must always see at most one decimal.
      input.addEventListener('input', function () { toOneDecimal(input); });
      input.addEventListener('input', function () { input.classList.remove('needs-attention'); });
      input.addEventListener('input', validate);
      input.addEventListener('input', refreshPrice);
      // A size cap reads these, so the rules re-run as the measurement is typed.
      input.addEventListener('input', notifyGroupChange);
      input.addEventListener('blur', validate);
    });

    /* The groups pick their defaults before this runs, when
       revealBoxesForShape was still the stub, so apply the shape once here. */
    if (rules) {
      var selectedShape = document.querySelector(
        '[data-option-group="' + rules.groupId + '"] .on');
      revealBoxesForShape(selectedShape && selectedShape.getAttribute('data-aid'));
    }

    validate();
  }

  /* --- 6. Quantity stepper --- */

  function initQuantity() {
    var display = document.getElementById('quantity-display');
    if (!display) return;

    function step(delta) {
      display.value = Math.max(1, (+display.value) + delta);
      setProp('cart-quantity', display.value);
    }

    document.querySelectorAll('[data-quantity-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        step(parseInt(button.getAttribute('data-quantity-step'), 10) || 0);
      });
    });
  }

  /* --- 7. Full-screen image viewer ---
     Re-reads the thumbnail rail on every open, so it shows the current fabric. */

  function initLightbox() {
    var dialog = document.getElementById('gallery-lightbox');
    var viewer = document.getElementById('lightbox-image');
    var counter = document.getElementById('lightbox-counter');
    if (!dialog || !viewer || typeof dialog.showModal !== 'function') return;

    var strings = window.maahoProductStrings || {};
    var images = [];
    var position = 0;

    var ZOOM_MS = 520;   // must match the transition on .lightbox-image
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /**
     * Zoom the viewer image out of, or back into, the clicked element: measure
     * both, transform the viewer onto the source, then release it (opening) or
     * apply it (closing).
     */
    function zoomFrom(source, direction, done) {
      if (!source || prefersReducedMotion.matches) {
        if (done) done();
        return;
      }

      var from = source.getBoundingClientRect();
      var to = viewer.getBoundingClientRect();
      if (!from.width || !to.width) {
        if (done) done();
        return;
      }

      // transform-origin is top left: shrink, then move.
      var scale = from.width / to.width;
      var offsetX = from.left - to.left;
      var offsetY = from.top - to.top;
      var collapsed = 'translate(' + offsetX + 'px,' + offsetY + 'px) scale(' + scale + ')';

      if (direction === 'in') {
        viewer.style.transition = 'none';
        viewer.style.transform = collapsed;
        // Force a reflow, or the browser optimises the collapsed state away.
        void viewer.offsetWidth;
        viewer.style.transition = '';
        viewer.style.transform = '';
        if (done) window.setTimeout(done, ZOOM_MS);
      } else {
        viewer.style.transition = '';
        viewer.style.transform = collapsed;
        window.setTimeout(function () {
          viewer.style.transform = '';
          if (done) done();
        }, ZOOM_MS);
      }
    }

    /** Current gallery, largest available version of each view. */
    function collectImages() {
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumbs img'));
      if (thumbs.length) {
        return thumbs.map(function (thumb) {
          return thumb.getAttribute('data-full') || thumb.src;
        });
      }
      return mainImg ? [mainImg.src] : [];
    }

    function show(index) {
      if (!images.length) return;

      position = (index + images.length) % images.length;   // wraps both ways
      viewer.src = images[position];

      // Replace the markup ratio hint with the real size.
      viewer.onload = function () {
        if (viewer.naturalWidth) {
          viewer.width = viewer.naturalWidth;
          viewer.height = viewer.naturalHeight;
        }
      };

      if (counter) {
        counter.textContent = formatMessage(strings.galleryCounter, {
          CURRENT: position + 1,
          TOTAL: images.length
        });
      }

        // Preload the neighbours.
      [position + 1, position - 1].forEach(function (neighbour) {
        var url = images[(neighbour + images.length) % images.length];
        if (url) new Image().src = url;
      });
    }

    function open() {
      images = collectImages();
      if (!images.length) return;

      dialog.toggleAttribute('data-single', images.length < 2);

      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumbs img'));
      var selected = thumbs.findIndex(function (thumb) {
        return thumb.classList.contains('on');
      });

      show(selected > -1 ? selected : 0);
      dialog.showModal();

        // After showModal, so the viewer has its final size.
      zoomFrom(mainImg, 'in');
    }

    /** Shrink back into the on-page image, then close. */
    function close() {
      if (!dialog.open) return;
      zoomFrom(mainImg, 'out', function () { dialog.close(); });
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-lightbox-open]')) { open(); return; }
      if (!dialog.open) return;

      if (event.target.closest('[data-lightbox-close]')) { close(); return; }

      var step = event.target.closest('[data-lightbox-step]');
      if (step) {
        show(position + parseInt(step.getAttribute('data-lightbox-step'), 10));
        return;
      }

      if (event.target === dialog) close();
    });

    document.addEventListener('keydown', function (event) {
      if (!dialog.open) return;
      if (event.key === 'ArrowRight') show(position + 1);
      if (event.key === 'ArrowLeft') show(position - 1);
    });

      // Take over Escape so it zooms out.
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      close();
    });

    dialog.addEventListener('close', function () {
      viewer.style.transition = '';
      viewer.style.transform = '';
    });
  }

  /* --- Boot --- */

  initVariantSwatches();
  bindThumbs();
  initFabricGroups();
  initOptionPanels();
  initDimensions();
  initQuantity();
  initLightbox();
  refreshPrice();     // after every group has registered its default choice
  updateAddToCartState();   // ditto: requiredGroupIds is only complete once every init above has run
})();
